import { useEffect, useRef, useState } from "react";
import WebViewer from "@pdftron/pdfjs-express-viewer";
import { twMerge } from "tailwind-merge";
import { Button } from "@components/Button";
import { MinusIcon, PlusIcon } from "@components/icons";
import { DOCUMENT_VIEWER_LICENSE_KEY } from "@/constants";

interface IAddBillPdfMethodAutomaticParsingModalPdfViewerProps {
  file: File;
  className?: string;
}

export const AddBillPdfMethodAutomaticParsingModalPdfViewer: React.FC<
  IAddBillPdfMethodAutomaticParsingModalPdfViewerProps
> = (props) => {
  const { file, className } = props;

  const viewer = useRef<HTMLDivElement>(null);
  const instance = useRef();
  // Hack to handle race condition, where instance ref is not set, but data is already fetched
  const [instanceChangeTracker, setInstanceChangeTracker] = useState(0);
  const [zoom, setZoom] = useState(1);

  /* eslint-disable */
  useEffect(() => {
    WebViewer(
      {
        path: "/pdfjs",
        licenseKey: DOCUMENT_VIEWER_LICENSE_KEY,
        disabledElements: [
          "header",
          "pageNavOverlay",
          "toolsOverlay",
          "contextMenuPopup",
        ],
      },
      viewer.current,
      // @ts-expect-error - cc
    ).then((inst) => {
      instance.current = inst;
      setInstanceChangeTracker((prev) => prev + 1);

      const iframeDoc = inst.UI.iframeWindow.document;

      iframeDoc
        ?.querySelector(".App")
        ?.setAttribute("style", "background: transparent;");
    });
  }, []);
  /* eslint-enable */

  useEffect(() => {
    // @ts-expect-error - cc
    // eslint-disable-next-line
    instance.current?.loadDocument(file);
  }, [file, instanceChangeTracker]);

  const handleZoom = (method: "zoomIn" | "zoomOut") => {
    if (instance.current) {
      if (method === "zoomIn") {
        setZoom((prev) => prev + 0.1);
      } else {
        setZoom((prev) => prev - 0.1);
      }
    }
  };

  useEffect(() => {
    if (instance.current) {
      // @ts-expect-error - cc
      // eslint-disable-next-line
      instance.current.setZoomLevel(zoom);
    }
  }, [zoom]);

  return (
    <div className={twMerge("relative", className)}>
      <div className="h-full" ref={viewer}></div>
      <div className="absolute bottom-4 left-4 flex flex-col gap-2">
        <Button icon={PlusIcon} onClick={() => handleZoom("zoomIn")} />
        <Button icon={MinusIcon} onClick={() => handleZoom("zoomOut")} />
      </div>
    </div>
  );
};
